/**
 * Mixin that provides the components with momaURLBuilder properties.
 */
export default {
    props: {
        /**
         * Closure that returns MOMA API URL for given endpoint and
         * query parameters.
         */
        momaURLBuilder: {
            type: Function,
            required: true,
        },
    },
};
